console.log("venatus prosper imported");
self.__VM = self.__VM || [];
self.__VM.push(function (admanager, scope) {
//scope.Config.get('mobile_banner').display('ad-layout-header');
//scope.Config.get('leaderboard').display('ad-layout-header');

scope.Config.get('mpu', 'footer-nav').display('ad-layout-footer-nav');
scope.Config.get('mpu', 'content-primary').display('ad-layout-content-primary');
scope.Config.get('mpu', 'content-secondary').display('ad-layout-content-secondary');


//scope.Config.get('mobile_banner').display('slot-3');
//scope.Config.get('desktop-sticky').display('ad-layout-desktop-sticky');
// Based on your layout, here are the responsive tags. The placement will change based on screen width.
// With the mobile breakpoint set by default at max-width:1024px

scope.Config.buildPlacement((configBuilder) => { 
	configBuilder.add("leaderboard"); 
 	configBuilder.addDefaultOrUnique("mobile_banner").setBreakPoint("mobile"); 
}, "layout-footer").display("ad-layout-footer-content"); 

scope.Config.buildPlacement((configBuilder) => { 
	configBuilder.add("leaderboard"); 
 	configBuilder.addDefaultOrUnique("mobile_banner").setBreakPoint("mobile"); 
}, "layout-header").display("ad-layout-header"); 

});
